const en_master_process = {
    "": "process",
    add: "add process",
    can_change: "can be changed",
    edit: "edit process",
    name: "process name",

    form: {
        can_change_title: "editable in transaction *",
        can_change_label: "enable to allow changes during transaction",
        btn_add_detail1: "add raw material",
        btn_add_detail2: "add process output",
    },

    error: {
        name: "Process name cannot be empty.",
        create: "Failed to create process.",
        delete: "Failed to delete process.",
        edit: "Failed to update process.",
    },

    success: {
        create: "Process created successfully.",
        delete: "Process deleted successfully.",
        edit: "Process updated successfully.",
    }
}

export default en_master_process;